interface SkeletonProps {
  width?: string
  height?: string
  className?: string
  shape?: 'rect' | 'circle'
}

export default function Skeleton({ width, height, className, shape = 'rect' }: SkeletonProps) {
  const cls = ['skeleton', shape === 'circle' ? 'skeleton-circle' : 'skeleton-rect', ...(className ? [className] : [])]
    .join(' ')
  const style: Record<string, string> = {}
  if (width) style.width = width
  if (height) style.height = height
  return <div className={cls} style={Object.keys(style).length > 0 ? style : undefined} />
}

export function SkeletonText({ lines = 2 }: { lines?: number }) {
  const widths = ['65%', '45%', '55%']
  return (
    <div className="skeleton-text-group">
      {Array.from({ length: lines }, (_, i) => (
        <div key={i} className={`skeleton skeleton-rect skeleton-text`} style={{ width: widths[i] ?? '50%' }} />
      ))}
    </div>
  )
}

export function SkeletonCard() {
  return (
    <div className="skeleton skeleton-card">
      <div className="skeleton skeleton-card-img" />
      <div className="skeleton-card-body">
        <div className="skeleton skeleton-rect skeleton-text" style={{ width: '65%' }} />
        <div className="skeleton skeleton-rect skeleton-text" style={{ width: '45%' }} />
        <div className="skeleton skeleton-rect skeleton-text" style={{ width: '25%', height: '1.1em' }} />
      </div>
    </div>
  )
}

export function SkeletonTableRow({ cells = 4 }: { cells?: number }) {
  return (
    <div className="skeleton skeleton-table-row">
      {Array.from({ length: cells }, (_, i) => (
        <div key={i} className={`skeleton skeleton-rect skeleton-table-cell`} />
      ))}
    </div>
  )
}

export function SkeletonOrderRow() {
  return (
    <div className="skeleton skeleton-order-row">
      <div className="skeleton skeleton-rect skeleton-order-cell" />
      <div className="skeleton skeleton-rect skeleton-order-cell" />
      <div className="skeleton skeleton-rect skeleton-order-cell" />
    </div>
  )
}